import React from "react";
import {
  TennisBall, Basketball, SoccerBall, Golf, Volleyball, Confetti,
} from "@phosphor-icons/react";

const MAP = {
  pickleball: TennisBall,
  padel: TennisBall,
  tennis: TennisBall,
  golf: Golf,
  basketball: Basketball,
  football: SoccerBall,
  volleyball: Volleyball,
};

export default function SportIcon({ slug, size = 18, weight = "duotone", className = "" }) {
  const Icon = MAP[slug] || Confetti;
  return <Icon size={size} weight={weight} className={className} />;
}
